import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import XImage from '@/components/@base/x-image';
import Props from '@/components/shared/components/cards/readySite/content/static-mode/type';
import IconLinkCombo from '@/components/shared/components/icon-link-combo';
import PriceView from '@/components/shared/components/price-view';

export default function StaticMode({
  isHovered,
  title,
  icon,
  productTitle,
  price,
  lastPrice,
  discount,
  saleEndedAt,
  sellable,
  slug,
  store,
}: Props) {
  return (
    <Container
      center
      className={cn(
        'absolute right-0 bottom-0 left-0 hidden h-[50%] w-full flex-col items-start justify-end gap-2 bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(2,2,3,0.657)_53.12%,rgba(4,4,5,0.9)_100%)] px-5 py-7 *:w-full md:flex',
        isHovered && 'shadow-none md:hidden',
      )}
    >
      <a className='text-md line-clamp-1 w-full! text-[#F4F5F6]' href={`/web/${slug}`}>
        {title}
      </a>
      <Container center className='w-full justify-between'>
        <IconLinkCombo
          Icon={
            <XImage
              src={store.logo.publicLink}
              width={22}
              height={22}
              alt={icon?.title}
              className='rounded-md!'
            />
          }
          textSize={SIZE_ENUM.XS}
          textClassName='line-clamp-1 w-full max-w-[120px] text-[#F4F5F6]'
          title={store.name}
          link={`/web/${slug}`}
          target='_blank'
        />
        <PriceView
          isDark={true}
          sellable={sellable}
          price={price}
          lastPrice={lastPrice}
          discount={discount}
          saleEndedAt={saleEndedAt}
          priceClassName='text-[#E5E8EB] font-bold text-md'
          currencyClassName='text-[11px] text-[#C1C3C8]'
        />
      </Container>
    </Container>
  );
}
